import { Pressable, View } from 'react-native';
import React from 'react';
import Modal from 'react-native-modal';
import { Button, Text } from '~/components';
import CarSVG from '~/assets/svgs/car.svg';
import CloseSVG from '~/assets/svgs/close.svg';
import colors from '~/assets/themes/colors';
import { isWeb } from '~/utils/device';
import useMarisaAutoForm from '~/stores/marisaAutoForm';

interface Props {
  visible: boolean;
  onClose: (type?: 'yes' | 'no') => void;
}

const HasInsuranceModal = ({ visible, onClose }: Props) => {
  return (
    <Modal
      isVisible={visible}
      className={`${isWeb ? 'items-center justify-center' : ''}`}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
      onSwipeComplete={() => onClose()}
      swipeDirection={['down']}
      propagateSwipe
    >
      <View className="items-center justify-center flex-1 px-6">
        <View className="bg-white p-6 rounded-2xl w-full">
          <Pressable className=" items-end" onPress={() => onClose()}>
            <CloseSVG color={colors.gray[400]} width={24} height={24} />
          </Pressable>

          <View className="items-center mb-6">
            <CarSVG />
          </View>

          <Text className="text-center text-xl mb-6">
            Seu veículo possui seguro?
          </Text>

          <View className="flex-column space-y-4">
            <Button
              onPress={() => {
                useMarisaAutoForm.getState().setExpiryDate('');
                onClose('no');
              }}
            >
              NÃO
            </Button>

            <Button variant="secondary" onPress={() => onClose('yes')}>
              SIM
            </Button>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default HasInsuranceModal;
